var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFutureEvent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 35,
    viewBox: "0 0 54 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2856 0L49.7278 18.8313L48.4423 20.3634L42 14.9577V26H54V28H52V33H54V35H24H22H0V33H2L2 28H0V26H12L12 14.7293L5.28557 20.3634L4 18.8313L26.4422 1.8993e-05L26.8639 0.502535L27.2856 0ZM24 33V24C24 22.3431 25.3431 21 27 21C28.6569 21 30 22.3431 30 24V28H32V24C32 21.2386 29.7614 19 27 19C24.2386 19 22 21.2386 22 24V33H14L14 13.0511L26.8639 2.257L40 13.2795V33H24ZM45 33H42V28H45V33ZM12 28V33H9V28H12ZM50 28V33H47V28H50ZM7 28H4L4 33H7L7 28Z",
    fill: "#767676"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureEvent);
export default __webpack_public_path__ + "static/media/futureEvent.3504dadb8d78eed5ce3cf5af3e58ef4e.svg";
export { ForwardRef as ReactComponent };